import { render, staticRenderFns } from "./DispatcherTasksTabSelectExecutor.vue?vue&type=template&id=4a9676e1&"
import script from "./DispatcherTasksTabSelectExecutor.vue?vue&type=script&lang=js&"
export * from "./DispatcherTasksTabSelectExecutor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QIcon,QItem,QSelect,QInput,QPopupProxy,QDate,QSpace,QTooltip,QBanner,QInnerLoading,QSpinnerGears,QSeparator,QCardActions,QBtn} from 'quasar'
component.options.components = Object.assign({QDialog,QCard,QCardSection,QIcon,QItem,QSelect,QInput,QPopupProxy,QDate,QSpace,QTooltip,QBanner,QInnerLoading,QSpinnerGears,QSeparator,QCardActions,QBtn}, component.options.components || {})
